import { estimateTrendIndicatorWidth } from '../../../TrendIndicator/utilities/estimateTrendIndicatorWidth.js';

function getTrendIndicatorData(trendMetadata) {
  if (trendMetadata != null) {
    const {
      totalWidth
    } = estimateTrendIndicatorWidth(`${trendMetadata.value}`);
    return {
      trendIndicatorProps: trendMetadata,
      trendIndicatorWidth: totalWidth
    };
  }

  return {
    trendIndicatorProps: undefined,
    trendIndicatorWidth: 0
  };
}

export { getTrendIndicatorData };
